import { StyleSheet } from '@react-pdf/renderer';

export const pdfPageStyles = StyleSheet.create({
  page: {
    backgroundColor: 'white',
  },
  sectionHeading: {
    margin: 10,
    padding: 10,
    textAlign: 'center',
    color: 'white',
    backgroundColor: 'black',
  },
  sections: {
    margin: 10,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '22px',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  sectionContainerVideo: {
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 20px',
  },
  sectionTableVideo: {
    border: '1px solid lightgray',
    width: '100%',
  },
  sectionTable: {
    border: '1px solid lightgray',
    padding: '10px 20px',
    width: '30%',
  },
  sectionTableRating: {
    border: '1px solid lightgray',
    padding: '10px 20px',
    width: '80%',
  },
  text: {
    fontSize: '12px',
    marginTop: '2px',
  },
  images: {
    width: '100%',
    height: '100px',
    objectFit: 'cover',
  },
  sectionContainerCol: {
    display: 'flex',
    flexDirection: 'row',
    width: '80%',
  },
  sectionMessage: {},
  viewer: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
});
